<p-dialog [(visible)]="display" [resizable]="true" [modal]="true" [style]="{'width': '640px'}"
	(onHide)="hide()" appendTo="body" styleClass="prtg-map-picker-dialog">
	<p-header>
		<span>{{ title }}</span>
	</p-header>

	@if (loading) {
	<div class="mb-2">Loading PRTG maps…</div>
	}

	@if (errorMessage) {
	<div class="mb-2 text-danger">{{ errorMessage }}</div>
	}

	@if (!loading && maps.length > 0) {
	<p-table [value]="maps" [(selection)]="selectedMap" selectionMode="single" dataKey="id"
		[scrollable]="true" scrollHeight="360px" styleClass="prtg-map-table">
		<ng-template pTemplate="header">
			<tr>
				<th style="width: 80px">ID</th>
				<th>Name</th>
				<th style="width: 180px">Tags</th>
			</tr>
		</ng-template>
		<ng-template pTemplate="body" let-row>
			<tr [pSelectableRow]="row" (dblclick)="onRowDoubleClick(row)">
				<td>{{ row.id }}</td>
				<td>{{ row.name }}</td>
				<td>{{ row.tags }}</td>
			</tr>
		</ng-template>
	</p-table>
	}

	<p-footer>
		<button type="button" pButton icon="fa fa-check" (click)="select()" label="Select"
			[disabled]="!enableSelect"></button>
		<button type="button" pButton icon="fa fa-close" (click)="cancel()" label="Cancel"></button>
	</p-footer>
</p-dialog>
